import * as React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import { CountryBase } from '../../templates/fragments/country'
import { RegionBase, RegionStub } from '../../templates/fragments/region'
import { DesktopFooter } from './footer/desktop'
import { MobileFooter } from './footer/mobile'

export const Footer = () => {
    const data: {
        bestDestinations: {
            bestCountries: CountryBase[],
            bestRegions: RegionStub[]
        }
    } = useStaticQuery(graphql`
    {
      bestDestinations: commonDataJson {
        bestCountries {
            ...CountryBase
        }
        bestRegions {
            ...RegionStub
        }
    }
    }
  `)

    return (<footer>
        <div className="md:hidden">
            <MobileFooter bestCountries={data.bestDestinations.bestCountries} bestRegions={data.bestDestinations.bestRegions} />
        </div>
        <div className="mdmax:hidden">
            <DesktopFooter bestCountries={data.bestDestinations.bestCountries} bestRegions={data.bestDestinations.bestRegions} />
        </div>
    </footer>
    )
}